
































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component
export default class OrderSnapshot extends Vue {
  goodsList: any[] = []
  get fromErp() {
    return !!this.$route.query.fromErp
  }

  async created() {
    await env.init()
    if (!this.fromErp && !(await env.getIsLogin())) {
      return await env.login()
    }
    const { data: data } = await this.$axios.get(
      '/api/service-m/v1/shop/order/goodsSnapshot',
      {
        params: {
          id: this.$route.query.id,
          check_login: 1 - +this.fromErp,
        },
      }
    )
    this.goodsList = data.data
  }

  toSanpshot(item) {
    this.$router.push({
      path: '/orderSnapshotnew',
      query: {
        tid: this.$route.query.tid,
        id: this.$route.query.id,
        skuId: item.sku_id,
        skuSnapshotId: item.sku_snapshot_id,
        fromErp: this.$route.query.fromErp || '',
      },
    })
  }
}
